import { Component, Input } from '@angular/core';
import { TpmItemsProcessorService } from '../../../../services/tpm-items-processor.service';
import { LicensePlateResponseModel } from '../../../../../modules/inventory/features/license-plate/models/response-models/license-plate-response.model';

@Component({
  selector: 'app-license-plate-item-details-card',
  standalone: false,
  templateUrl: './license-plate-item-details-card.component.html',
  styleUrl: './license-plate-item-details-card.component.css',
})
export class LicensePlateItemDetailsCardComponent {
  @Input() licensePlate?: LicensePlateResponseModel | null;
  @Input() canShowHeader: boolean = true;

  isCollapsed: boolean = true;
  constructor(private tpmItemsProcessorService: TpmItemsProcessorService) {}

  ngOnInit() {
    if (!this.canShowHeader) {
      this.isCollapsed = false;
    }
  }

  getShortProductName(productName: string | null | undefined): string {
    return this.tpmItemsProcessorService.extractProductName(productName ?? '');
  }

  toggle() {
    if (this.canShowHeader) {
      this.isCollapsed = !this.isCollapsed;
    }
  }
}
